import { BackgroundStyleSetter } from "../../../Formily/src/setters";
import { TreeNode } from "@designable/core";
import { ISchema } from "@formily/react";
import { ClickEventSetter, ClickCustomEventSetter } from "../../../Formily/src/setters";
import { SideBarSetter, TabBarSetter } from '../setters'

export const Form: ISchema = {
  type: "object",
  properties: {
    "layout-group": {
      type: "void",
      "x-component": "FormTab",
      "x-component-props": {
        centered: true,
        animated: true,
        className: "formily-tab-centered",
      },
      properties: {
        "theme-group": {
          type: "void",
          "x-component": "FormTab.TabPane",
          "x-component-props": {
            tab: "页面配置",
          },
          properties: {
            showNav: {
              title: "显示导航栏",
              "x-decorator": "FormItem",
              type: "boolean",
              "x-component": "Switch",
            },
            showSideBar: {
              title: "显示侧边栏",
              "x-decorator": "FormItem",
              type: "boolean",
              "x-component": "Switch",
            },
            showTabBar: {
              title: "显示标签栏",
              "x-decorator": "FormItem",
              type: "boolean",
              "x-component": "Switch",
            },
            navBarProps: {
              type: "object",
              "x-component": "CollapseItem",
              "x-reactions": [
                {
                  dependencies: [".showNav"],
                  fulfill: {
                    state: {
                      visible: "{{$deps[0]}}",
                    },
                  },
                },
              ],
              properties: {
                title: {
                  title: "标题",
                  type: "string",
                  "x-decorator": "FormItem",
                  "x-component": "Input",
                  "x-component-props": {
                    placeholder: "标题",
                    defaultValue: "标题",
                  },
                },
                backArrow: {
                  title: "返回箭头",
                  type: "string",
                  "x-decorator": "FormItem",
                  "x-component": "Switch",
                  "x-component-props": {
                    defaultChecked: true,
                  },
                },
                back: {
                  title: "返回区域文字",
                  type: "string",
                  "x-decorator": "FormItem",
                  "x-component": "Input",
                  "x-component-props": {
                    placeholder: "返回区域文字",
                  },
                  "x-reactions": [
                    {
                      dependencies: [".backArrow"],
                      fulfill: {
                        state: {
                          visible: "{{$deps[0]}}",
                        },
                      },
                    },
                  ],
                },
                clickEventProps: {
                  title: "返回箭头事件",
                  type: "Object",
                  "x-decorator": "FormItem",
                  "x-component": ClickEventSetter,
                  "x-component-props": {
                    senceType: "modal",
                  },
                  "x-reactions": [
                    {
                      dependencies: [".backArrow"],
                      fulfill: {
                        state: {
                          visible: "{{$deps[0]}}",
                        },
                      },
                    },
                  ],
                },
                clickCustomEventProps: {
                  title: '返回箭头能力',
                  type: 'Object',
                  'x-decorator': 'FormItem',
                  'x-component': ClickCustomEventSetter,
                  "x-reactions": [
                    {
                      dependencies: [".backArrow"],
                      fulfill: {
                        state: {
                          visible: "{{$deps[0]}}",
                        },
                      },
                    },
                  ],
                },
                "style.background": {
                  title: "背景",
                  "x-component": BackgroundStyleSetter,
                },
              },
            },
            sideBarProps: {
              type: "object",
              "x-component": "CollapseItem",
              "x-reactions": [
                {
                  dependencies: [".showSideBar"],
                  fulfill: {
                    state: {
                      visible: "{{$deps[0]}}",
                    },
                  },
                },
              ],
              properties: {
                tabs: {
                  title: '数据',
                  type: 'array',
                  'x-decorator': 'FormItem',
                  'x-component': SideBarSetter,
                },
                defaultActiveKey: {
                  title: '默认选中',
                  type: 'string',
                  "x-decorator": 'FormItem',
                  "x-component": 'Select',
                  enum: [],
                  "x-component-props": {
                    placeholder: '请选择',
                    allowClear: true,
                    fieldNames: {
                      label: 'label',
                      value: 'key',
                    },
                  },
                  "x-reactions": (field) => {
                    const items = field.query('.tabs').value()
                    if (Array.isArray(items)) {
                      const enums = items.map((item) => {
                        return {
                          label: item.title,
                          key: item.key,
                        }
                      })
                      field.setDataSource(enums)
                    }
                  }
                },
                "style.background": {
                  title: "背景",
                  "x-component": BackgroundStyleSetter,
                },
              }
            },
            tabBarProps: {
              type: 'object',
              "x-component": "CollapseItem",
              "x-reactions": [
                {
                  dependencies: [".showTabBar"],
                  fulfill: {
                    state: {
                      visible: "{{$deps[0]}}",
                    },
                  },
                },
              ],
              properties: {
                tabs: {
                  title: '标签页数据',
                  type: 'array',
                  'x-decorator': 'FormItem',
                  'x-component': TabBarSetter,
                },
                activeKey: {
                  title: '默认选中',
                  type: 'string',
                  "x-decorator": 'FormItem',
                  "x-component": 'Select',
                  enum: [],
                  "x-component-props": {
                    placeholder: '请选择',
                    allowClear: true,
                    fieldNames: {
                      label: 'label',
                      value: 'key',
                    },
                  },
                  "x-reactions": (field) => {
                    const items = field.query('.tabs').value()
                    if (Array.isArray(items)) {
                      const enums = items.map((item) => {
                        return {
                          label: item.title,
                          key: item.key,
                        }
                      })
                      field.setDataSource(enums)
                    }
                  }
                },
                "style.background": {
                  title: "背景",
                  "x-component": BackgroundStyleSetter,
                },
              }
            }
          },
        },
        "style-group": {
          type: "void",
          "x-component": "FormTab.TabPane",
          "x-component-props": {
            tab: "样式",
          },
          properties: {
            "style.background": {
              "x-component": BackgroundStyleSetter,
            },
          },
        },
      },
    },
  },
};
